<div
	*ngIf="vo$ | async as vo"
	class="dcds-tag-chip"
	[class.dcds-tag-chip--keyword]="vo.variant === 'keyword'"
	[class.dcds-tag-chip--tint]="vo.fill === 'tint'"
	[class.dcds-tag-chip--highlighted]="vo.highlighted"
	[style.--_color]="vo.variant === 'keyword' ? null : vo.color"
	[style.--_label-color]="
		vo.variant === 'keyword'
			? null
			: vo.labelColor === 'white'
			? 'var(--dcc-global-white-clr)'
			: 'var(--dcc-global-black-clr)'
	"
	[attr.tabindex]="vo.collapsed ? 0 : null"
	[attr.aria-label]="vo.collapsed ? vo.label : null">
	<span
		class="dcds-tag-chip__dot"
		*ngIf="vo.variant === 'tag' && vo.color !== 'transparent'"
		aria-hidden="true"></span>
	<span
		class="dcds-tag-chip__label"
		[title]="vo.label"
		[attr.aria-hidden]="vo.collapsed ? true : null"
		>{{ vo.label }}</span
	>

	<ng-container *ngIf="vo.menu; else bareRemove">
		<button
			#menuTrigger
			cdkOverlayOrigin
			#menuOrigin="cdkOverlayOrigin"
			type="button"
			class="dcds-tag-chip__menu-trigger"
			draggable="false"
			(click)="toggleMenu()"
			[attr.aria-expanded]="menuOpen"
			aria-haspopup="menu"
			aria-label="actions"
			i18n-aria-label="@@ui-sdk.tag.menu">
			<svg
				viewBox="0 -960 960 960"
				width="1em"
				height="1em"
				fill="currentColor"
				aria-hidden="true">
				<path
					d="M480-160q-33 0-56.5-23.5T400-240q0-33 23.5-56.5T480-320q33 0 56.5 23.5T560-240q0 33-23.5 56.5T480-160Zm0-240q-33 0-56.5-23.5T400-480q0-33 23.5-56.5T480-560q33 0 56.5 23.5T560-480q0 33-23.5 56.5T480-400Zm0-240q-33 0-56.5-23.5T400-720q0-33 23.5-56.5T480-800q33 0 56.5 23.5T560-720q0 33-23.5 56.5T480-640Z" />
			</svg>
		</button>

		<ng-template
			cdkConnectedOverlay
			[cdkConnectedOverlayOrigin]="menuOrigin"
			[cdkConnectedOverlayOpen]="menuOpen"
			cdkConnectedOverlayPanelClass="dcds-tag-chip-menu-panel"
			(overlayOutsideClick)="closeMenu()">
			<div class="dcds-tag-chip__menu" role="menu">
				<button
					type="button"
					class="dcds-tag-chip__menu-item"
					role="menuitem"
					(click)="triggerEdit()">
					<svg
						viewBox="0 -960 960 960"
						width="1em"
						height="1em"
						fill="currentColor"
						aria-hidden="true">
						<path
							d="M200-200h57l391-391-57-57-391 391v57Zm-80 80v-170l528-527q12-11 26.5-17t30.5-6q16 0 31 6t26 18l55 56q12 11 17.5 26t5.5 30q0 16-5.5 30.5T846-654L318-120H120Zm584-528-56-56 56 56Zm-141 85-28-29 57 57-29-28Z" />
					</svg>
					<span i18n="@@ui-sdk.tag.edit">Edit</span>
				</button>
				<button
					type="button"
					class="dcds-tag-chip__menu-item"
					role="menuitem"
					[disabled]="!vo.canShiftLeft"
					(click)="triggerShiftLeft()">
					<svg
						viewBox="0 -960 960 960"
						width="1em"
						height="1em"
						fill="currentColor"
						aria-hidden="true">
						<path d="M560-240 320-480l240-240 56 56-184 184 184 184-56 56Z" />
					</svg>
					<span i18n="@@ui-sdk.tag.shiftLeft">Move left</span>
				</button>
				<button
					type="button"
					class="dcds-tag-chip__menu-item"
					role="menuitem"
					[disabled]="!vo.canShiftRight"
					(click)="triggerShiftRight()">
					<svg
						viewBox="0 -960 960 960"
						width="1em"
						height="1em"
						fill="currentColor"
						aria-hidden="true">
						<path d="M504-480 320-664l56-56 240 240-240 240-56-56 184-184Z" />
					</svg>
					<span i18n="@@ui-sdk.tag.shiftRight">Move right</span>
				</button>
				<button
					type="button"
					class="dcds-tag-chip__menu-item dcds-tag-chip__menu-item--danger"
					role="menuitem"
					(click)="triggerRemove()">
					<svg
						viewBox="0 -960 960 960"
						width="1em"
						height="1em"
						fill="currentColor"
						aria-hidden="true">
						<path
							d="M280-120q-33 0-56.5-23.5T200-200v-520h-40v-80h200v-40h240v40h200v80h-40v520q0 33-23.5 56.5T680-120H280Zm400-600H280v520h400v-520ZM360-280h80v-360h-80v360Zm160 0h80v-360h-80v360ZM280-720v520-520Z" />
					</svg>
					<span i18n="@@ui-sdk.tag.remove">Remove</span>
				</button>
			</div>
		</ng-template>
	</ng-container>

	<ng-template #bareRemove>
		<button
			*ngIf="vo.removable"
			type="button"
			class="dcds-tag-chip__remove"
			(click)="triggerRemove()"
			aria-label="remove"
			i18n-aria-label="@@ui-sdk.tag.remove">
			<svg
				viewBox="0 -960 960 960"
				width="1em"
				height="1em"
				fill="currentColor"
				aria-hidden="true">
				<path
					d="m250.92-218.92-32-32L448-480 218.92-709.08l32-32L480-512l229.08-229.08 32 32L512-480l229.08 229.08-32 32L480-448 250.92-218.92Z" />
			</svg>
		</button>
	</ng-template>
</div>
